
  export default {
    mounted() {
      this.image = this.el.querySelector("#chat-lightbox-image")

      // Delegated from the document because the bubbles live in a stream that re-renders
      // under us, and the dialog is not their ancestor.
      this.onOpen = (event) => {
        const opener = event.target.closest("[data-lightbox]")
        if (!opener) return

        event.preventDefault()
        this.image.src = opener.dataset.lightbox
        this.el.showModal()
      }
      document.addEventListener("click", this.onOpen)

      this.el.addEventListener("click", () => this.el.close())

      // Drop the source on close so a large image is not held in memory, and so the next
      // open never flashes the previous one.
      this.el.addEventListener("toggle", (event) => {
        if (event.newState === "closed") this.image.src = ""
      })
    },

    destroyed() {
      document.removeEventListener("click", this.onOpen)
    }
  }
